export default [
  {
    path: '/',
    name: 'Home',
    component: resolve => require(['@/pages/Home'], resolve)
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js